angular.module('jv.video.recruiter.evaluations.controller',[])
    .controller('VideoEvalsParentCtrl',[angular.noop])
    //Children evaluation Controller
    .controller('VideoEvalsSnippetCtrl',['$scope', 'videoService', '$rootScope', '$window', '$jobviteUrls',
        function($scope, videoService, $rootScope, $window, $jobviteUrls) {
            $scope.setMiniHeader = function() {
                var hash = $window.location.hash.substring(2);
                $rootScope.miniHeader = {
                    show: true,
                    back: hash
                };
            };
            $scope.sendReminder = function(modelObj) {
                $scope.flags.loading = true;
                $rootScope.$broadcast('evalSendReminder', modelObj.pendingEvaluators, modelObj.interviewId);
            };
            var visibleIndex = null;
            $scope.showTooltip = function(index) {
                if (index == visibleIndex) {
                    $scope.allEvaluations[visibleIndex].tooltip = false;
                    visibleIndex = null;
                    return;
                }
                if (visibleIndex !== null) {
                    $scope.allEvaluations[visibleIndex].tooltip = false;
                }
                $scope.allEvaluations[index].tooltip = true;
                visibleIndex = index;
            };

            var setUpModel = function(allInterviews) {
                $scope.allEvaluations = [];
                if (angular.isUndefined(allInterviews) || allInterviews.length === 0) {
                    return;
                }
                for (var i = 0, j = allInterviews.length; i < j; i++) {
                    var object = allInterviews[i];
                    var modelObj = {};
                    modelObj.form = object.form;
                    modelObj.usersInfoObj = {};
                    if (object.users.length === 0) {
                        continue;
                    }
                    angular.forEach(object.users, function(user, key) {
                        modelObj.usersInfoObj[user.EId] = user;
                    });
                    modelObj.evalPendingUserIds = object.pendingList;
                    modelObj.pendingEvaluators = [];
                    angular.forEach(object.pendingList, function(val, index) {
                        modelObj.pendingEvaluators[index] = modelObj.usersInfoObj[val.userEId];
                    });
                    modelObj.interviewId = object.interviewId;
                    modelObj.evalDoneUserIdsYes = [];
                    modelObj.evalDoneUserObjsYes = [];
                    modelObj.evalDoneUserIdsNo = [];
                    modelObj.evalDoneUserObjsNo = [];
                    angular.forEach(object.resultList, function(result, key) {
                        if (result.completionDate !== null) {
                            modelObj.completionDate = result.completionDate;
                            if (result.rating === 1) {
                                modelObj.evalDoneUserIdsYes.push(result.userEId);
                                modelObj.evalDoneUserObjsYes.push(modelObj.usersInfoObj[result.userEId]);
                            } else if (result.rating === 0) {
                                modelObj.evalDoneUserIdsNo.push(result.userEId);
                                modelObj.evalDoneUserObjsNo.push(modelObj.usersInfoObj[result.userEId]);
                            }
                        }
                    });
                    // mapper for jhire UI
                    modelObj.state = {};
                    //{'yes': userObj}
                    modelObj.state.list = {};
                    modelObj.state.list['YES'] = modelObj.evalDoneUserObjsYes;
                    modelObj.state.list['NO'] = modelObj.evalDoneUserObjsNo;
                    modelObj.state.list['_PENDING'] = modelObj.pendingEvaluators;
                    $scope.allEvaluations.push(modelObj);
                }
            };
            //get All evaluations
            var getAllEvaluations = function() {
                videoService.getAllEvaluations({
                    'applicationEId': $scope.applicationId
                }, function(results) {
                    setUpModel(results.list);
                });
            };
            getAllEvaluations();

            $scope.printEvals = function(){
                $window.open($jobviteUrls.video + '/video/recruiter/videoPrintPreviewAllEvalsPopout.html?noHeader=true&applicationId=' + $scope.applicationId);
            };
        }
    ])
    .controller('VideoEvalsCtrl',['$scope', 'videoService', '$rootScope', '$location', '$jobviteUrls', '$window',
        function($scope, videoService, $rootScope, $location, $jobviteUrls, $window) {
            //VA: This is for view of evaluations inside the video tab.
            $scope.interviewId = $location.search().interviewId || $location.path().split('/')[4];
            $scope.appId = $location.search().applicationId || $location.path().split('/')[3] || $scope.applicationEId;
            $scope.displayType = $location.search().displayType || $location.path().split('/')[5] || 'grid'; //list, grid, print
            $scope.users = null;
            $scope.flags = $scope.flags || {};
            // Get all the questions for an interview.
            $scope.questions = [];
            // create the user comments dictionary.
            $scope.userCommentsDictionary = {};
            $scope.modelForChildScope = {
                requestMoreInformation: function(item) {
                    var object = item;
                    object.interviewId = $scope.userCommentsDictionary[item.EId].evalID;
                    object.formId = $scope.interviewId;
                    $scope.flags.loading = true;
                    $rootScope.$broadcast('evalRequestMoreInformation', object);
                },
                sendReminder: function() {
                    $scope.flags.loading = true;
                    $rootScope.$broadcast('evalSendReminder', $scope.modelForChildScope.pendingEvaluators, $scope.interviewId);
                }
            };
            //Open page for printed evaluations
            $scope.printEvals = function() {
                window.open($jobviteUrls.video + '/video/recruiter/evaluationGrid.html#/?interviewId=' + $scope.interviewId + '&displayType=print&applicationId=' + $scope.appId);
            };
            // set the miniheader
            $scope.setMiniHeader = function() {
                var hash = $window.location.hash.substring(2);
                $rootScope.miniHeader = {
                    show: true,
                    back: hash
                };
            };
            $scope.evalTooltip = false;
            // old version of angular doesn't haev sanitization providers. Putting this hack for the time being.
            function sanitize(text) {
                if (angular.isUndefined(text) || text === null || typeof text !== 'string') {
                    return text;
                }
                return $('<div></div>').text(text).html().replace(/\n/g, '<br/>');
            }
            function setScopeData(result) {
                $scope.evaluationTitle = result.form.title;
                $scope.modelForChildScope.userHash = {};
                $scope.modelForChildScope.pendingEvaluators = [];
                $scope.interviewId = $scope.interviewId || result.interviewId;
                // Get all the questions for an interview.
                $scope.questions = result.form.questions;
                // fill the user comments dictionary.
                angular.forEach(result.users, function(value) {
                    $scope.modelForChildScope.userHash[value.EId] = value;
                });
                angular.forEach(result.pendingList, function(val, index) {
                    $scope.modelForChildScope.pendingEvaluators[index] = $scope.modelForChildScope.userHash[val.userEId];
                });
                angular.forEach(result.resultList, function(value) {
                    $scope.userCommentsDictionary[value.userEId] = {};
                    $scope.userCommentsDictionary[value.userEId].completionDate = value.completionDate;
                    $scope.userCommentsDictionary[value.userEId].evalID = value.SId;
                    //overall evaluation
                    $scope.userCommentsDictionary[value.userEId].overallEvaluation = {};
                    //debugger;
                    $scope.userCommentsDictionary[value.userEId].overallEvaluation.comment = sanitize(value.comment);
        
                    $scope.userCommentsDictionary[value.userEId].overallEvaluation.rating = value.rating;
                    //other comments for questions
                    angular.forEach(value.evaluations, function(evaluation) {
                        evaluation.comment = sanitize(evaluation.comment);
                        $scope.userCommentsDictionary[value.userEId][evaluation.question.SId] = evaluation;
                    });
                });
                var users = [];
                //don't show the users who haven't entered any evaluation. They will be shown as part of pendingEvaluators.
                angular.forEach(result.users, function(value) {
                    if (!!$scope.userCommentsDictionary[value.EId]) {
                        users.push(value);
                    }
                });
                // Get the user sequence array.
                $scope.users = users;
            }
            if ($scope.displayType === 'print') {
                videoService.getAppDetails({
                    id: $scope.appId
                }, function(results) {
                    $scope.appDetails = results;
                    //VA: angular takes time to render, so sometimes the print appears without the information filled properly in the UI. Giving some breathing space to render.
                    $scope.$evalAsync(window.print);
                });
            }
            if (angular.isUndefined($scope.interviewId)) {
                var rendered = false;
                $scope.$watch('interviewEvaluation', function(newValue) {
                    if (typeof newValue !== 'undefined' && rendered === false) {
                        setScopeData(newValue);
                        rendered = true;
                    }
                });
            } else {
                //VA: its part of the video tab. show only a specific interview evaluations.
                videoService.getEvaluations({
                    id: $scope.interviewId,
                    appId: $scope.appId
                }, function(results) {
                    setScopeData(results);
                    $scope.flags.loading = false;
                });
            }
        }]
);